import { sendPdf } from "@hardware/Services/VmiBinsService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { CallApi, chain } from "@insite/client-framework/Store/Pages/VmiLocationDetails/Handlers/SendVmiBinsPdf";

replaceInChain(chain, CallApi, async props => {
    props.apiResult = await sendPdf(props.apiParameter);
});
